import './addModal.scss'
import { useState, useEffect } from 'react'
import Text from '../../../../components/text-component/Text'
import { getStaticText } from '../../../../lables/lablesService'
import Button from '../../../../components/button-component/Button'

/**
 * Component add row in the table
 * 
 * @params toggle - func
 * @params errors - variable
 * @params isEdit - boolean
 * @params dataTable - arr obj
 * @params addRowsValue - func
 * @params handleValidation - func
 * 
 * @returns JSX
 */
const AddModal = ({
    toggle,
    errors,
    dataTable,
    addRowsValue,
    setDataTable,
    fetchPageList,
    successfulMsg,
    unsuccessfulMsg,
    handleValidation,
    setSuccessfulMsg,
    setUnsuccessfulMsg
}) => {

    //State for add new row
    let [addFormData, setAddFormData] = useState({
        iso: "",
        flag: "",
        name: "",
        active: true,
        is_default: null
    });

    //State for mount component
    const [didMount, setDidMount] = useState(false);
    //State for disabled button
    const [disabledBtn, setDisabledBtn] = useState(false);
    //State for show/hide error message
    const [isAlertSuccessfulVisible, setIsAlertSuccessfulVisible] = useState(false);
    //State for show/hide error message
    const [isAlertUnsuccessfulVisible, setIsAlertUnsuccessfulVisible] = useState(false);

    /**
     * The method changes the active input value 
     * 
     * @params event 
     */
    const handleChangeCheckedActive = event => {
        setAddFormData(prev => ({
            ...prev,
            active: event.target.checked
        }))
    };

    /**
     * The method changes the default input value 
     * 
     * @params  event 
     */
    const handleChangeCheckedDefault = event => {
        setAddFormData(prev => ({
            ...prev,
            is_default: event.target.checked
        }))

    };

    useEffect(() => {

        let timeout;

        if (unsuccessfulMsg) {
            setIsAlertUnsuccessfulVisible(true)

            timeout = window.setTimeout(() => {
                setIsAlertUnsuccessfulVisible(false);
                setUnsuccessfulMsg("");
                setDisabledBtn(prev => !prev);
            }, 3000)

        }

        return () => window.clearTimeout(timeout);

    }, [unsuccessfulMsg, setUnsuccessfulMsg])

    useEffect(() => {
        let timeout;

        if (successfulMsg) {
            setIsAlertSuccessfulVisible(true)

            timeout = window.setTimeout(() => {
                setIsAlertSuccessfulVisible(false);
                setSuccessfulMsg("")
                toggle();
                setAddFormData("");
            }, 3000)
        }

        return () => window.clearTimeout(timeout);

    }, [successfulMsg, setSuccessfulMsg, toggle])

    /**
     * Method submit the form and add a new row in table
     * 
     * @params event 
     */
    const handleAddFormSubmit = async event => {
        event.preventDefault();

        if (disabledBtn) return;

        setDisabledBtn(prev => !prev);

        let newRow = {
            iso: addFormData.iso,
            flag: addFormData.flag,
            name: addFormData.name,
            active: addFormData.active,
            is_default: addFormData.is_default
        };

        //Input field validation
        if (handleValidation(newRow)) {

            const resp = await addRowsValue(newRow);
            addFormData = [...dataTable, { ...newRow, id: resp.id }];

            setDataTable(addFormData);

            await fetchPageList();
        } else {

            setDisabledBtn(prev => !prev);
        }
    };

    /**
     * The method of changing the value of the input field
     * 
     * @params event 
     */
    const handleAddFormChange = (event) => {
        event.preventDefault();

        const fieldName = event.target.getAttribute("name");
        const fieldValue = event.target.value.trim();

        const newFormData = { ...addFormData };
        newFormData[fieldName] = fieldValue;

        setAddFormData(newFormData);
    };

    useEffect(() => {
        setDidMount(true);
        return () => setDidMount(false);
    }, [])

    if (!didMount) {
        return null;
    }

    return (
        <form className="p-4 pt-2 pb-2" onSubmit={handleAddFormSubmit}>
            {/* Render success unsuccess error message */}
            {
                isAlertUnsuccessfulVisible &&
                (unsuccessfulMsg &&
                    <Text
                        content={unsuccessfulMsg}
                        text_style={"alert alert-danger p-0 pt-1 pb-1 text-center h6"}
                    />
                )
            }
            {
                isAlertSuccessfulVisible &&
                (successfulMsg &&
                    <Text
                        content={successfulMsg}
                        text_style={"alert alert-success p-0 pt-1 pb-1 text-center h6"}
                    />
                )
            }
            <Text
                content={getStaticText('add_form_name')}
                text_style={"text-left d-flex ml-1 mb-0 h6"}
            />

            {/* Show/hide error msg */}
            <p className='h6 error_msg'>
                {errors && errors['iso']}
            </p>
            <input
                type="text"
                name="name"
                autoComplete="off"
                value={addFormData.name || ''}
                onChange={handleAddFormChange}
                className="form-control shadow-none mt-1"
                placeholder={getStaticText('add_form_placeholder')}
            />

            <Text
                content={getStaticText('add_form_ico')}
                text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
            />
            {/* Show/hide error msg */}
            <p className='h6 error_msg'>
                {errors && errors['name']}
            </p>
            <input
                type="text"
                name="iso"
                autoComplete="off"
                value={addFormData.iso || ''}
                onChange={handleAddFormChange}
                className="form-control shadow-none mt-1"
                placeholder={getStaticText('add_form_placeholder')}
            />

            <Text
                content={getStaticText('add_form_flag')}
                text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
            />
            {/* Show/hide error msg */}
            <p className='h6 error_msg'>
                {errors && errors['flag']}
            </p>
            <input
                type="text"
                name="flag"
                autoComplete="off"
                value={addFormData.flag || ''}
                onChange={handleAddFormChange}
                className="form-control shadow-none mt-1"
                placeholder={getStaticText('add_form_placeholder')}
            />

            <Text
                content={getStaticText('add_defoult_lng')}
                text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
            />
            <span className='add_checkbox'>
                <input
                    name="is_default"
                    type={"checkbox"}
                    className='checkbox'
                    checked={addFormData.is_default}
                    onChange={handleChangeCheckedDefault}
                />
                <span className='m-1'>{getStaticText('checkbox_default')}</span>
            </span>

            <Text
                content={getStaticText('add_active_lng')}
                text_style={"text-left d-flex ml-1 mb-0 h6 pt-2"}
            />
            <span className='add_checkbox'>
                <input
                    name="active"
                    type={"checkbox"}
                    className='checkbox'
                    checked={addFormData.active}
                    onChange={handleChangeCheckedActive}
                />
                <span className='m-1'>{getStaticText('checkbox_default')}</span>
            </span>

            <Button
                type='submit'
                bgcolor={"danger"}
                btn_disabled={disabledBtn}
                btn_styles={"btn-active text-white shadow-none mt-2 mb-2"}
                label={disabledBtn ? getStaticText('loading_btn') : getStaticText('submit_btn')}
            />

        </form>
    )
}

export default AddModal;